import { combineReducers } from '@reduxjs/toolkit';
import { reducer as alerts } from 'react-notification-system-redux';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import account from './account/reducer';
import auth from './auth/slice';
import asyncFilters from './async-filters/reducer';
import sidebar from './sidebar/reducer';
import tables from './tables/reducer';
import lists from './lists/reducer';
import marketIndexes from './market-indexes/reducer';
import fuelGrades from './fuel-grades/reducer';
import widgetTypes from './widget-types/reducer';
import integrations from './integrations/reducer';
import routes from './routes/reducer';
import crewRank from './crew-rank/reducer';
import vessels from './vessels/reducer';
import beacon from './beacon';
import eventTypes from './event-types/slice';
import reports from './reports/slice';
import companySettings from './company-settings/slice';

export const history = createBrowserHistory();

const combinedReducer = combineReducers({
  account,
  auth,
  alerts,
  asyncFilters,
  router: connectRouter(history),
  sidebar,
  lists,
  tables,
  marketIndexes,
  fuelGrades,
  widgetTypes,
  integrations,
  routes,
  crewRank,
  vessels,
  beacon,
  eventTypes,
  reports,
  companySettings
});

function rootReducer(state, action) {
  switch (action.type) {
    default:
      return combinedReducer(state, action);
  }
}

export default rootReducer;
